import styled from 'styled-components';

type Props = { width?: string };

const InputWrapper = styled.div<Props>`
  ${({ theme, width = '16rem' }) => `
    margin-right: ${theme.spacing(4)}px;
    max-width: ${width};
    display: flex;
    flex: 1;
    > .MuiTextField-root {
      width: 100%;
    }
  `};
`;

export default InputWrapper;
